import { CtProduct } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    title: {
      field: 'title',
      label: 'Title',
      validator: () => true,
      type: 'string',
      required: true
    },
    sku: {
      field: 'sku',
      label: 'Stock keeping unit',
      validator: () => true, // TODO write async validator that checks if the sku exists
      type: 'string',
      required: false
    },
    price: {
      field: 'price',
      label: 'Base Price',
      validator: () => true, // TODO write async validator that checks if the sku exists
      type: 'number',
      required: false
    },
    ean: {
      field: 'ean',
      label: 'European Article Number (EAN)',
      validator: () => true,
      type: 'tag',
      required: false
    },
    components: {
      field: 'components',
      label: 'Product Components (stock-items)',
      validator: () => true,
      contentType: 'stock',
      type: 'link-list',
      required: false
    },
    options: {
      field: 'options',
      label: 'Options',
      validator: () => true,
      contentType: 'prop',
      type: 'link-list',
      default: [],
      required: false
    },
    fixed_fulfillment_tier: {
      field: 'fixed_fulfillment_tier',
      label: 'Fixed packing',
      validator: () => true,
      contentType: 'packing',
      type: 'link-list',
      required: false
    },
    variants: {
      field: 'variants',
      label: 'Product variants',
      validator: () => true,
      contentType: 'product',
      type: 'link-list',
      required: false
    },
    categories: {
      field: 'categories',
      label: 'Product Categories',
      validator: () => true,
      contentType: 'category',
      type: 'link-list',
      required: false,
      default: null
    }
  }

const state = {}
const getters = {}
const mutations = {}
const actions = {}
const options = {
  // import: true
}

export default ContentModule<CtProduct>(
  ContentType.Product, 'Services/Directr', model,
  state,
  getters,
  mutations,
  actions,
  options)
